<template>
  <div>
    <v-student-profile
      v-if="!teacher&&!isLoading"
      :studentId="studentId"
      @teacher-avatar-click="toTeacher"/>
    <v-student-teacher-base
      v-else-if="teacher&&!isLoading"
      :studentId=studentId
      :teacher=teacher
      @close-button-click="toStudent()" />
  </div>
</template>

<script>
import VStudentProfile from '@/components/organisms/parent/VStudentProfile.vue'
import VStudentTeacherBase from '@/components/organisms/parent/VStudentTeacherBase.vue'

export default {
  components: {
    VStudentProfile,
    VStudentTeacherBase
  },
  data () {
    return {
      parent: this.$store.getters.parent,
      teacher: null,
      studentId: null,
      isLoading: true
    }
  },
  methods: {
    toTeacher(teacher) {
      this.teacher = teacher
    },
    toStudent() {
      this.teacher = null
    }
  },
  created () {
    this.studentId = this.$route.params.studentId
    this.isLoading = false
  }
}
</script>
